import { SortingState } from '@amzn/awsui-collection-hooks/dist/cjs/interfaces';
export const defaultSortBy = <T>(sortingField: string, descending = true): SortingState<T> => {
    return {
        isDescending: descending,
        sortingColumn: {
            sortingField,
        },
    };
};
